import React from "react";
import { motion } from "framer-motion";

// Twinkling star cluster. Replaces the campfire glyph that closed the hero and
// the footer.
//
// The "glow" is done with opacity and scale only — no blur filter and no
// gradient, so it stays inside the design contract. Four-pointed stars keep the
// hard-edged vocabulary; a soft round dot would read as the wrong system.

// Sharp four-pointed star with concave sides, drawn around (0,0).
const starPath = (r) =>
  `M 0 ${-r} Q ${r * 0.16} ${-r * 0.16} ${r} 0 ` +
  `Q ${r * 0.16} ${r * 0.16} 0 ${r} ` +
  `Q ${-r * 0.16} ${r * 0.16} ${-r} 0 ` +
  `Q ${-r * 0.16} ${-r * 0.16} 0 ${-r} Z`;

// x, y, radius, twinkle period, phase offset
const STARS = [
  { x: 30, y: 20, r: 11, dur: 2.4, delay: 0 },
  { x: 12, y: 38, r: 6, dur: 3.1, delay: 0.7 },
  { x: 47, y: 34, r: 7, dur: 2.7, delay: 1.3 },
  { x: 38, y: 49, r: 4, dur: 3.6, delay: 0.4 },
  { x: 19, y: 12, r: 3.5, dur: 2.9, delay: 1.9 },
];

/**
 * @param size   rendered px width/height
 * @param color  star fill
 */
const StarMark = ({ size = 60, color = "#ff8236", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 60 60"
    aria-hidden="true"
    {...rest}
  >
    {/* The translate lives on a plain <g>. framer-motion writes its own
        transform when animating scale, so putting both on one node would
        discard the offset and collapse every star onto the origin. */}
    {STARS.map((s, i) => (
      <g key={i} transform={`translate(${s.x}, ${s.y})`}>
        <motion.path
          d={starPath(s.r)}
          fill={color}
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          animate={{ opacity: [0.35, 1, 0.35], scale: [0.85, 1, 0.85] }}
          transition={{
            duration: s.dur,
            repeat: Infinity,
            ease: "easeInOut",
            delay: s.delay,
          }}
        />
      </g>
    ))}
  </svg>
);

export default StarMark;
